import {
  type CreateTopupRequest,
  type FeeRate,
  feeRateSchema,
  type Topup,
  topupSchema,
} from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export function fetchFeeRate(): Promise<FeeRate> {
  return apiRequest('/billing/fee-rate', feeRateSchema)
}

export function createTopup(body: CreateTopupRequest): Promise<Topup> {
  return apiRequest('/billing/topups', topupSchema, { method: 'POST', body })
}

/**
 * Payment is detected by polling, not a callback: the dialog calls this every
 * few seconds while a QR is on screen. The server throttles its own upstream
 * checks, and a background sweep covers users who close the tab after paying.
 */
export function fetchTopupStatus(id: string, force = false): Promise<Topup> {
  return apiRequest(`/billing/topups/${encodeURIComponent(id)}`, topupSchema, {
    // `force` comes from the "I have paid" button and skips the server's poll
    // throttle, so the answer reflects the gateway right now.
    query: force ? { force: 'true' } : {},
  })
}
